import React from 'react';
import TextInput from '../UI/Form/TextInput';
import ImageSelect from '../UI/Form/ImageSelect';
import TextArea from '../UI/Form/TextArea';
import BooleanField from '../UI/Form/BooleanField';
import SelectDropDown from '../UI/Form/SelectDropDown';
import Attributes from '../Attributes/Attributes';
import GenerateText from '../utils/AI/GenerateText';
import {instructions} from '../Constants/Instructions';
import AppConstants from '../Constants/AppConstants';
import {replacePlaceholders} from '../utils/replacePlaceholders';
import ToastPopup from '../HelperClasses/AppLoaderClasses/ToastPopup';

const AccountForm = ({
  form_state,
  onUpdateForm,
  categories,
  attributes,
  attributeData,
  setAttributeData,
  users,
}) => {
  return (
    <div className=" max-h-[90dvh] h-full overflow-y-auto border border-gray-200 rounded-md py-4 px-5 w-[97%] m-3 flex flex-col gap-3  ">
      {/* Image */}
      <ImageSelect
        title={'Image'}
        current_data={form_state?.image_path}
        update_data={value => {
          onUpdateForm({key: 'image_path', value: value});
        }}
      />
      {/* Title */}
      <TextInput
        title={'Name'}
        current_data={form_state?.name}
        placeholder={'Account Name'}
        type={'text'}
        update_data={data => onUpdateForm({key: 'name', value: data})}
        isRequired={true}
      />
      {/* Title */}
      <TextInput
        title={'Slug'}
        current_data={form_state?.slug}
        placeholder={'Account SLug'}
        type={'text'}
        update_data={data => onUpdateForm({key: 'slug', value: data})}
      />
      {/* Description */}
      {/* make thsi as absolute view on top of the description view */}
      <div className=" relative">
        <TextArea
          title={'Description'}
          current_data={form_state?.description}
          placeholder={'Account Description'}
          type={'text'}
          update_data={data => onUpdateForm({key: 'description', value: data})}
        />
        <div className=" absolute top-10 right-4 h-6 w-6 ">
          <GenerateText
            system_instruction={instructions.account_description.system}
            user_id={AppConstants.userId}
            user_message={replacePlaceholders({
              template: instructions.account_description.user,
              data: {
                store_name: form_state?.name,
              },
            })}
            openSide="right"
            disabled={!form_state?.name}
            onDisabledAlert={() =>
              ToastPopup({
                type: 'error',
                message: 'Please enter a title first',
              })
            }
            isShowCopyButton={true}
            type={'account_description'}
          />
        </div>
      </div>
      {/* Users */}{' '}
      <SelectDropDown
        name={'users'}
        title={'User'}
        selected_value={form_state?.user_id}
        setValue={value => onUpdateForm({key: 'user_id', value: value})}
        list={users?.map(c => ({label: c.email, value: c.id})) || []}
        default_text={'Select user'}
        isRequired={true}
      />
      {/* categories */}{' '}
      <SelectDropDown
        name={'category'}
        title={'Category'}
        selected_value={form_state?.category}
        setValue={value => onUpdateForm({key: 'category', value: value})}
        list={categories?.map(c => ({label: c.name, value: c.id}))}
        default_text={'Select Type'}
      />
      {/*  */}
      <Attributes
        attributeData={attributeData}
        setAttributeData={setAttributeData}
        attributes={attributes}
      />
    </div>
  );
};

export default AccountForm;
